import React from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button'
//import CardMenu from './CardMenu';
import {setDismissNotisByUserid} from 'actions'
import { isUndefined } from 'lodash';
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({auth}) {
  const { authUser} = auth;
  return {
    authUser
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setDismissNotisByUserid: (userid) => dispatch(setDismissNotisByUserid(userid)),
  };
}
class CardHeader extends React.Component {


  onOptionMenuSelect = event => {
    this.setState({menuState: true, anchorEl: event.currentTarget});
  };
  handleRequestClose = () => {
    this.setState({menuState: false});
  };

  constructor() {
    super();
    this.state = {
      anchorEl: undefined,
      menuState: false,
    }
  }
  setDismissNotisByUserid=()=>{
    const userid = this.props.authUser.user_id
    this.props.setDismissNotisByUserid(userid)
  }
  render() {
    const {heading, subHeading} = this.props;
    let {styleName} = this.props;
    //const {anchorEl, menuState} = this.state;
    return (
      <div className={`jr-card-header d-flex align-items-start ${styleName}`}>
        <div className="mr-auto">
          <h3 className="card-heading">{heading} {isUndefined(this.props.notificationLength) ? '' : this.props.notificationLength === 0 ? '' : ` (${this.props.notificationLength})`}</h3>
          {subHeading && <p className="sub-heading">{subHeading}</p>}
        </div>

        <Button 
        onClick={this.setDismissNotisByUserid}
        ><IntlMessages id="Notification.Dismiss.all" /></Button>
        
      </div>
    )
  }
}

export default connect(
    mapStateToProps,mapDispatchToProps
  )(CardHeader);


